import { useQueryClient as y, useMutation as c, useQuery as a } from "@tanstack/react-query";
import n from "./users.api.js";
import { teachurKeys as r } from "../../constants/teachurKeys.js";
const f = (e = {}, t) => a({
  queryKey: r.users.searchStudents(e),
  queryFn: async () => (await n.searchStudents(e)).data,
  placeholderData: (s) => s,
  staleTime: 3e4,
  ...t
}), q = (e) => a({
  queryKey: r.users.currentUser(),
  queryFn: async () => (await n.getCurrentUser()).data,
  staleTime: 1 / 0,
  ...e
}), w = (e) => a({
  queryKey: r.users.loginStreak(),
  queryFn: async () => (await n.getLoginStreak()).data,
  ...e
}), F = (e, t) => a({
  queryKey: r.users.detail(e),
  queryFn: async () => (await n.get(e)).data,
  enabled: !!e,
  ...t
}), Q = (e) => a({
  queryKey: r.users.list(),
  queryFn: async () => (await n.list()).data,
  ...e
}), g = (e) => {
  const t = y();
  return c({
    mutationFn: async ({ id: s, data: u }) => (await n.update(s, u)).data,
    onSuccess: (s, u) => {
      t.setQueryData(r.users.detail(u.id), s), t.invalidateQueries({ queryKey: r.users.list() });
    },
    meta: {
      successMessage: "User updated successfully",
      errorMessage: "Failed to update user"
    },
    ...e
  });
}, C = (e) => {
  const t = y();
  return c({
    mutationFn: async (s) => {
      await n.delete(s);
    },
    onSuccess: (s, u) => {
      t.removeQueries({ queryKey: r.users.detail(u) }), t.invalidateQueries({ queryKey: r.users.list() });
    },
    meta: {
      successMessage: "User deleted successfully",
      errorMessage: "Failed to delete user"
    },
    ...e
  });
}, d = (e, t) => {
  if (!e)
    return t;
  const s = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(e);
  return s != null && s[1] ? decodeURIComponent(s[1]) : t;
}, K = (e) => c({
  mutationFn: async () => {
    var l;
    const t = await n.downloadEnrollmentVerificationLetter(), s = d(
      (l = t.headers) == null ? void 0 : l["content-disposition"],
      "enrollment-verification-letter.pdf"
    ), u = new Blob([t.data], { type: "application/pdf" }), i = URL.createObjectURL(u), o = document.createElement("a");
    o.href = i, o.download = s, document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(i);
  },
  ...e
});
export {
  C as useDeleteUserMutation,
  K as useDownloadEnrollmentVerificationLetterMutation,
  q as useGetCurrentUserQuery,
  w as useGetLoginStreakQuery,
  F as useGetUserQuery,
  Q as useGetUsersQuery,
  f as useSearchStudentsQuery,
  g as useUpdateUserMutation
};
